'use strict';

import React, {Component} from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import classnames from "classnames";

import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";

import {capitalize} from "@uw-it-sis/lib-react/lib/Utils";

import optionalChargesStore from "./OptionalChargesStore";
import {Campus} from '@uw-it-sis/lib-react/lib/AppConstants';

class OpChargeUpass extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.store = optionalChargesStore;
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        this.store.updateFormData(name, value);
    }

    submitForm = (e) => {
        e.preventDefault();
        this.props.onSuccess();
    }

    render() {
        const campus = this.props.campus;
        const data = this.store.data;
        const formData = this.store.formData;

        if ( data.upass_sw === "B" || data.upass_sw === "A" || data.eligible_sw === "N" ) {
            return null;
        }

        let isUpdatable = (data.upass_update_sw === "Y");
        let reason = parseInt(data.upass_reason);
        let amount = (Number(data.upass_amt) > 0) ? Number(data.upass_amt).toFixed(2) : "xxx.xx";

        let upassInfoLink, upassTermsLink, upassVanpoolText, upassToGo;
        let campusName = capitalize(campus);
        switch (campus) {
            case Campus.seattle:
                upassInfoLink = "http://www.washington.edu/u-pass/";
                upassTermsLink = upassInfoLink;
                upassVanpoolText = "";
                upassToGo = "";
                break;
            case Campus.bothell:
                upassInfoLink = "http://www.uwb.edu/administration-planning/facilities/transportation/upass";
                upassTermsLink = "http://www.washington.edu/u-pass/";
                upassVanpoolText = ", and Central Link light rail";
                upassToGo = "Please contact your Cashier's Office.";
                break;
            case Campus.tacoma:
                upassInfoLink = "http://www.tacoma.uw.edu/getting-campus/what-u-pass";
                upassTermsLink = "http://www.tacoma.uw.edu/getting-campus/u-pass-program-terms-use";
                upassVanpoolText = ", Central Link light rail, plus a monthly vanpool subsidy";
                upassToGo = <>Please order your Tacoma U-PASS <a href='http://www.tacoma.uw.edu/getting-campus/student-u-pass-order-form'>here</a>.</>
                break;
        }

        const upassReasons = {
            0: " ",
            1: "I need a car immediately before/after school for work, childcare and/or other purposes.",
            2: "There's not enough bus/train service.",
            3: "I'm not interested in options other than driving.",
            4: "I already have a transit pass from another source.",
            5: "I use Intercity Transit which is not covered in the U-PASS.",
            90: "Other."
        }

        let upassReasonsOptions = Object.entries(upassReasons).map(([key, value], i) => {
            return <option key={i} value={key}>{value}</option>;
        });

        let pastDeadline, upassForm;
        if (! isUpdatable) {
            let nextButton;
            if (this.props.showButton) {
                nextButton = <div><Button onClick={this.props.onSuccess}>Continue</Button></div>
            }
            pastDeadline =
                <>
                    <p>It is past the deadline to change your U-PASS selection here. {upassToGo}</p>
                    {nextButton}
                </>
        } else {
            let disableButton = (
                ( formData.UPASS === "Y" && formData.UPASSTOU !== "Y" )
                ||
                ( formData.UPASS === "N" && Object.keys(upassReasons).includes(formData.UPASSRSN.toString()) )
            )
            upassForm =
                <Form onSubmit={this.submitForm}>
                    <fieldset>
                        <legend className="h3">U-PASS selection:</legend>
                        <Form.Check
                            label={`Yes, I want the benefits of U-PASS membership. Add $${amount} to my bill for membership.`}
                            name="UPASS"
                            type="radio"
                            value="Y"
                            defaultChecked={formData.UPASS === "Y"}
                            onChange={this.handleChange}
                            id={`upass-yes`}
                        />
                        <Form.Check id={`upass-tou`} className={classnames({"d-none": !(formData.UPASS === "Y")})}>
                            <Form.Check.Input
                                name="UPASSTOU"
                                type="checkbox"
                                value="Y"
                                defaultChecked={formData.UPASSTOU === "Y"}
                                onChange={this.handleChange} />
                            <Form.Check.Label className="d-inline me-2 align-middle">
                                I have read and agree to the {campusName} U-PASS <a href={upassTermsLink} target="_blank">Terms of Use</a>.
                            </Form.Check.Label>
                        </Form.Check>
                        <Form.Check
                            label="No, I do not want the benefits of U-PASS membership."
                            name="UPASS"
                            type="radio"
                            value="N"
                            defaultChecked={formData.UPASS === "N"}
                            onChange={this.handleChange}
                            id={`upass-no`}
                        />
                        <Form.Group controlId="upass-reason" className={classnames({"d-none": !(formData.UPASS === "N")})}>
                            <Form.Label>Please select a reason:</Form.Label>
                            <Form.Select defaultValue={formData.UPASSRSN} onChange={this.handleChange}>
                                {upassReasonsOptions}
                            </Form.Select>
                        </Form.Group>
                    </fieldset>
                    <Button aria-disabled={disableButton} type="submit" className={classnames({"disabled": disableButton})}>Continue</Button>
                </Form>
        }

        return (
            <>
                <h4 className="h2">U-PASS</h4>
                <p>The <a href={upassInfoLink} target="_blank">U-PASS</a> is a full featured transit pass. It gives students access to
                    unlimited free rides on buses (Sound Transit, Pierce Transit, Kitsap Transit, King County Metro, Everett Transit,
                    and Community Transit), Sounder commuter rail{upassVanpoolText}. If you choose to purchase a U-PASS membership,
                    ${amount} will be included on your tuition-billing statement.</p>
                {pastDeadline}
                {upassForm}
            </>
        );
    }
}

OpChargeUpass.propTypes = {
    campus: PropTypes.string.isRequired,
    showButton: PropTypes.bool
}

OpChargeUpass.defaultProps = {
    showButton: false
}

export default observer(OpChargeUpass);